class clocks {
    constructor(
        id,
        name,
        descripcion,
        wsRcpcom,
        cat,
        ws) {
        this.id = id;
        this.name = name;
        this.descripcion= descripcion;
        this.wsRcpcom = wsRcpcom;
        this.cat = cat;
        this.ws = ws;
    }
    static fromJson({
        relojId,
        nombre,
        descrip,
        wsRcpcom,
        cat,
        ws
    }) {
        return new clocks(
            relojId,
            nombre,
            descrip,
            wsRcpcom,
            cat,
            ws
        );
    }
}
export default clocks;
